// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';

export default function Portal() {
    const { user } = useAuth();
    const { t, lang, td} = useI18n();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/chat/customer-dashboard')
            .then((res) => setData(res.data.data))
            .catch(() => setData({ bookings: [], totals: {} }))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="text-center py-5"><div className="spinner-border text-success" /></div>;
    }

    const bookings = data?.bookings || [];
    const totals = data?.totals || {};

    return (
        <div>
            <h4 className="mb-1">{t('welcome_user', { name: user?.name || '' })}</h4>
            <p className="text-muted mb-4">
                {t('portalSubtitle')}
            </p>

            <div className="row g-3 mb-4">
                <div className="col-md-4">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">{t('totalPayable')}</div>
                        <div className="fs-5 fw-bold">৳ {(totals.total_payable || 0).toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-4">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">{t('totalPaid')}</div>
                        <div className="fs-5 fw-bold text-success">৳ {(totals.total_paid || 0).toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-4">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">{t('totalDue')}</div>
                        <div className="fs-5 fw-bold text-danger">৳ {(totals.total_due || 0).toLocaleString()}</div>
                    </div></div>
                </div>
            </div>

            <div className="d-flex gap-2 mb-3 flex-wrap">
                <Link to="/chat" className="btn btn-primary btn-sm">
                    <i className="bi bi-chat-dots me-1"></i>
                    {t('supportChat')}
                </Link>
                <Link to="/portal/payments" className="btn btn-outline-primary btn-sm">
                    <i className="bi bi-receipt me-1"></i>
                    {t('paymentHistory')}
                </Link>
            </div>

            {bookings.length === 0 ? (
                <div className="card table-card">
                    <div className="card-body text-center py-5 text-muted">
                        <i className="bi bi-house display-4 d-block mb-3"></i>
                        {t('noBookingsYet')}
                    </div>
                </div>
            ) : (
                <div className="row g-3">
                    {bookings.map((b) => (
                        <div className="col-lg-6" key={b.booking_id}>
                            <div className="card table-card h-100">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <h5 className="mb-0">{b.project?.name}</h5>
                                            <small className="text-muted">{b.project?.code} · {b.project?.location}</small>
                                        </div>
                                        <span className="badge bg-info text-dark badge-status text-capitalize">
                                            {t('projectLabel')}
                                            {(b.project?.status || '').replace('_', ' ')}
                                        </span>
                                    </div>
                                    <p className="small text-muted mb-2">
                                        Unit {b.unit?.unit_number}
                                        {b.unit?.unit_type ? ` · ${b.unit.unit_type.replace('_', ' ')}` : ''}
                                        {b.unit?.size_sqft ? ` · ${b.unit.size_sqft} sqft` : ''}
                                        {b.project?.expected_completion ? (
                                            <span> · {t('expected')}: {b.project.expected_completion}</span>
                                        ) : null}
                                    </p>

                                    <div className="row g-2 small mb-3">
                                        <div className="col-4">
                                            <div className="text-muted">{t('salePriceLabel')}</div>
                                            <div className="fw-semibold">৳ {b.final_price.toLocaleString()}</div>
                                        </div>
                                        <div className="col-4">
                                            <div className="text-muted">{t('paid')}</div>
                                            <div className="fw-semibold text-success">৳ {b.paid_amount.toLocaleString()}</div>
                                        </div>
                                        <div className="col-4">
                                            <div className="text-muted">{t('due')}</div>
                                            <div className="fw-semibold text-danger">৳ {b.due_amount.toLocaleString()}</div>
                                        </div>
                                    </div>

                                    {b.next_payment_date && (
                                        <div className="alert alert-warning py-2 small mb-3">
                                            <i className="bi bi-calendar-event me-1"></i>
                                            {t('next_payment_on', { date: b.next_payment_date })}
                                            {' · '}৳ {Number(b.next_payment_amount).toLocaleString()}
                                        </div>
                                    )}

                                    <div className="d-flex gap-2 flex-wrap">
                                        <Link to={`/portal/bookings/${b.booking_id}`} className="btn btn-outline-primary btn-sm">
                                            {t('detailsInstallments')}
                                        </Link>
                                        <Link to={`/chat?booking_id=${b.booking_id}`} className="btn btn-outline-secondary btn-sm">
                                            <i className="bi bi-chat me-1"></i> Chat
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
